import React from 'react';
import { TextField, MenuItem } from '@mui/material';
import { resultInputSx, resultSelectMenuProps } from '../../styles/wizardStyles';

const RESULT_OPTIONS = [
  { value: '1 - 0', label: '1 - 0' },
  { value: '0 - 1', label: '0 - 1' },
  { value: '½ - ½', label: '½ - ½' },
  { value: '+ - -', label: '+ - -' },
  { value: '- - +', label: '- - +' },
  { value: '- - -', label: '- - -' },
];

/**
 * Compact select for chess match results (1-0, 0-1, ½-½, +-, -+, --).
 *
 * Props:
 *  - value: string
 *  - onChange: (e) => void
 *  - label: string (default 'Resultado')
 *  - disabled: boolean
 *  - placeholder: string (default '...')
 */
export default function MatchResultSelect({
  value,
  onChange,
  label = 'Resultado',
  disabled = false,
  placeholder = '...',
}) {
  return (
    <TextField
      select
      fullWidth
      size="small"
      label={label}
      value={value}
      onChange={onChange}
      disabled={disabled}
      InputLabelProps={{ style: { color: '#94a3b8' } }}
      SelectProps={{ style: { color: '#cbd5e1' }, MenuProps: resultSelectMenuProps }}
      sx={resultInputSx}
    >
      <MenuItem value="">
        <em>{placeholder}</em>
      </MenuItem>
      {RESULT_OPTIONS.map((opt) => (
        <MenuItem key={opt.value} value={opt.value}>
          {opt.label}
        </MenuItem>
      ))}
    </TextField>
  );
}
